import Alert from 'react-s-alert';
import i18n from 'src/i18n';
import { bellImage } from 'views/practitioner/services/svgImages';

export const alertInfo = (message, options) => {
  const defaultOptions = { position: 'bottom-right', offset: 30 };
  const opt = { ...defaultOptions, ...options };
  Alert.info(message || i18n.t('snack_bar_not_ready_feature'), opt);
};

export const alertError = message => {
  Alert.error(i18n.t(message) || i18n.t('snack_bar_server_error'), {
    position: 'bottom-right',
    offset: 30
  });
};

export const alertSuccess = message => {
  Alert.success(message || i18n.t('snack_bar_not_ready_feature'), {
    position: 'bottom-right',
    offset: 30
  });
};

export const closeAllAlerts = () => Alert.closeAll();

// can't set stack limit for 1 element
export const alertUnplannedReceived = () => {
  Alert.warning(
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {bellImage(true, false, true)}
      <span style={{ paddingLeft: '0.8em' }}>{i18n.t('unplanned_arrivals_available')}</span>
    </div>,
    {
      position: 'bottom-left',
      offset: 30,
      timeout: 'none'
    }
  );
};
